// extracted by mini-css-extract-plugin
export default {"slider":"common-slider_slider__Iayof","container":"common-slider_container__17dIm","label":"common-slider_label__xprYG","volume":"common-slider_volume__hN587"};